export default "__VITE_ASSET__CjvUWxlu__"